import { getItemsFromCollection } from "directus/src/operations";

export async function fetchTimesheet({ startDate }) {
  try {
    const query = {
      fields: ["date", "logged_hours", "approved_hours", "unapproved_hours"],
      filter: {
        date: {
          _gte: startDate,
        },
        employee: { user: { _eq: "$CURRENT_USER" } },
      },
      limit: -1,
    };

    return await getItemsFromCollection("timesheet", query);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchDraftTimesheet({ startDate }) {
  try {
    const query = {
      fields: ["date", "logged_hours"],
      filter: {
        date: {
          _gte: startDate,
        },
        employee: { user: { _eq: "$CURRENT_USER" } },
      },
      limit: -1,
    };

    return await getItemsFromCollection("draft_timesheet", query);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchThisMonthAvailableHours({ startDate }) {
  try {
    const query = {
      fields: ["date", "payroll_hours"],
      filter: {
        date: {
          _gte: startDate,
        },
        employee: { user: { _eq: "$CURRENT_USER" } },
      },
      limit: -1,
    };

    return await getItemsFromCollection("daily_work_capacity", query);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
